import { fetchAPI } from '../helpers';
import AppContext from '../AppContext';

class IdentityService {
    static getMyInfo = () => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.IdentityService}platform/${platformId}/user/me`,
            method: 'GET',
        });
    };

    static getMyPlatforms = () => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();

        return fetchAPI({
            token,
            url: `${config.IdentityService}my-platforms`,
            method: 'GET',
        });
    };

    //Invitations
    static acceptInvitation = (platformId, invitationToken) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();

        return fetchAPI({
            token: token,
            url: `${config.IdentityService}platform/${platformId}/accept-invitation/${invitationToken}`,
            method: 'PUT',
            body: {},
        });
    };

    static sendInvitation = (newInvitationMail, groups) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.IdentityService}platform/${platformId}/invite/${newInvitationMail}`,
            method: 'PUT',
            body: {
                groups,
            },
        });
    };

    // User groups
    static searchGroups = (nameBeginsWith, lastKey) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.IdentityService}platform/${platformId}/group/search`,
            method: 'POST',
            body: {
                nameBeginsWith,
                lastKey,
            },
        });
    };

    static getGroup = (groupId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.IdentityService}platform/${platformId}/group/${groupId}`,
            method: 'GET',
        });
    };

    static createGroup = (name) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.IdentityService}platform/${platformId}/group`,
            method: 'PUT',
            body: {
                name,
            },
        });
    };

    static deleteGroup = (groupId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.IdentityService}platform/${platformId}/group/${groupId}`,
            method: 'DELETE',
            body: {},
        });
    };

    static changeGroupName = (groupId, name) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.IdentityService}platform/${platformId}/group/${groupId}`,
            method: 'PUT',
            body: {
                name,
            },
        });
    };

    // User
    static searchUsers = (nameBeginsWith, useCurrentUserSub, lastKey) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();
        let currentUserSub = appContext.getMyInfo().userSub;

        return fetchAPI({
            token: token,
            url: `${config.IdentityService}platform/${platformId}/user/search`,
            method: 'POST',
            body: {
                nameBeginsWith,
                userSub: useCurrentUserSub === true ? currentUserSub : undefined,
                lastKey,
            },
        });
    };

    static getUser = (userSub) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.IdentityService}platform/${platformId}/user/${userSub}`,
            method: 'GET',
        });
    };

    static setUserProfileData = (name, userProfileData) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.IdentityService}platform/${platformId}/user/me`,
            method: 'PUT',
            body: {
                name,
                userProfileData,
            },
        });
    };

    static addUserToGroup = (userSub, groupId, isEditor) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.IdentityService}platform/${platformId}/group/${groupId}/user/`,
            method: 'PUT',
            body: {
                userSub,
                isEditor,
            },
        });
    };

    static removeUserFromGroup = (userSub, groupId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.IdentityService}platform/${platformId}/group/${groupId}/user/${userSub}`,
            method: 'DELETE',
            body: {},
        });
    };

    static removeUserFromPlatform = (userSub) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.IdentityService}platform/${platformId}/user/${userSub}`,
            method: 'DELETE',
            body: {},
        });
    };

    static makeAdminForPlatform = (userSub, isAdmin) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.IdentityService}platform/${platformId}/user`,
            method: 'PUT',
            body: {
                userSub,
                isAdmin,
            },
        });
    };

    static requestAccessToPlatform = (platformId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();

        return fetchAPI({
            token: token,
            url: `${config.IdentityService}platform/${platformId}/request-access`,
            method: 'GET',
        });
    };

    static attemptToMigrateUser = () => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();

        return fetchAPI({
            token: token,
            url: `${config.IdentityService}platform/attempt-migrate-user`,
            method: 'GET',
        });
    };
}

export default IdentityService;
